import Paper from '@zenbusiness/zui/Paper';

export const CustomPaper = ({ children, ...props }) => {
  // check if any options to render
  if (children?.[2] === null) {
    return null;
  }
  return (
    <Paper
      elevation={8}
      {...props}
    >
      {children}
    </Paper>
  );
};
